import { useEffect, useState } from "react";
import { coffreFileUrl } from "./coffre";

const logoCache = new Map<string, string>();
const logoWait = new Map<string, Promise<void>>();

export function warmFicheMark(path: string): Promise<void> {
  if (!path || logoCache.has(path)) return Promise.resolve();
  const pending = logoWait.get(path);
  if (pending) return pending;
  const run = fetch(coffreFileUrl(path), { credentials: "include" })
    .then((res) => (res.ok ? res.blob() : null))
    .then((blob) => {
      if (!blob) return;
      logoCache.set(path, URL.createObjectURL(blob));
    })
    .catch(() => undefined)
    .then(() => undefined);
  logoWait.set(path, run);
  return run;
}

/** Attend les logos déjà en cache, ou un court délai, pour les poser en même temps que les tâches. */
export function warmFicheLogos(paths: string[], timeoutMs = 900): Promise<void> {
  const jobs = [...new Set(paths.filter(Boolean))].map((path) => warmFicheMark(path));
  if (jobs.length === 0) return Promise.resolve();
  return Promise.race([
    Promise.all(jobs).then(() => undefined),
    new Promise<void>((resolve) => window.setTimeout(resolve, timeoutMs)),
  ]);
}

export function FicheMark({ path, name, className, tone, bare = false }: { path: string; name: string; className: string; tone?: "prospect" | "client" | "former"; bare?: boolean }) {
  const [url, setUrl] = useState(() => (path ? logoCache.get(path) || "" : ""));

  useEffect(() => {
    if (!path) {
      setUrl("");
      return;
    }
    const known = logoCache.get(path);
    if (known) {
      setUrl(known);
      return;
    }
    let alive = true;
    void warmFicheMark(path).then(() => {
      if (alive) setUrl(logoCache.get(path) || "");
    });
    return () => {
      alive = false;
    };
  }, [path]);

  const letter = name.trim().charAt(0).toUpperCase() || "·";
  return (
    <span className={`grid shrink-0 place-items-center overflow-hidden rounded-full font-semibold crm-ink crm-soft ${bare ? "" : `ring-2 ${tone === "client" ? "ring-emerald-500" : tone === "former" ? "ring-slate-400" : tone === "prospect" ? "ring-amber-400" : "ring-slate-300"}`} ${className}`}>
      {url ? <img src={url} alt="" className="h-full w-full object-cover" /> : letter}
    </span>
  );
}
